import { render, staticRenderFns } from "./PersonApply.vue?vue&type=template&id=7f313738&scoped=true&"
import script from "./PersonApply.vue?vue&type=script&lang=js&"
export * from "./PersonApply.vue?vue&type=script&lang=js&"
import style0 from "./PersonApply.vue?vue&type=style&index=0&id=7f313738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f313738",
  null
  
)

export default component.exports